import { Tag } from 'src/services/tag/Tag';

export function getLevelTag(tag: Tag): number {
  const path = tag.fullPath.split('/');
  return path.length;
}
